<template>
  <div class="tree-view">
    <tree-view-item
      ref="treeView"
      :data="data[0]"
      :collapsed="true"
      :depth="0"
      :numbering="getNumbering()"
      :priority="priority == 'max'"
      :default-value="defaultValue"
      :titles="titles"
      :channel-id="channelId"
      v-bind="{ flat, focus, tips }"
      @updated="$emit('updated')"
      @click="clickedDate=new Date()"/>
  </div>
</template>

<script>
export default {
  name: 'TreeView',

  props: {
    data: {
      required: true,
      type: [Array, Object]
    },
    defaultValue: {
      default: 5,
      type: Number
    },
    flat: {
      default: false,
      type: Boolean
    },
    focus: {
      default: null,
      type: Object
    },
    numbering: {
      default: '',
      type: [String, Number]
    },
    priority: {
      default: 'min',
      type: String
    },
    tips: {
      type: String
    },
    titles: {
      type: String
    },
    withKeyboardShortcuts: {
      default: false,
      type: Boolean
    }
  },

  data: () => ({
    badge: null,
    selection: null,
    channelId: null
  }),

  computed: {
    treeView () {
      return this.$refs.treeView
    }
  },
  mounted () {
    // Generate unique id
    this.channelId = this.generateID()
    // Listen to keyboard for evaluation selection
    if (this.withKeyboardShortcuts) {
      this._keyListener = function (e) {
        var visible = $(this.$el).is(':visible')
        if (visible) {
          if (e.key >= 0 && e.key <= 5 && e.key != ' ') {
            this.$root.$emit('treeviewitem_setvalue_' + this.channelId, e.key)
          } else if (e.key == 'Tab') {
            this.$store.state.seartchingTreeViewItem = true
            this.$root.$emit('treeviewitem_selectnext_' + this.channelId)
            e.preventDefault()
          }
        }
      }
      document.addEventListener('keydown', this._keyListener.bind(this))
    }
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this._keyListener)
  },

  methods: {
    getMask () {
      return this.treeView.getMask([])
    },

    /**
       * Returns correct numbering.
       */
    getNumbering () {
      // If has focus, use focussed element's numbering.
      if (this.focus && this.focus.getNumbering) {
        return this.focus.getNumbering()
      }

      return this.numbering
    },

    hasChildren () {
      return Object.keys(this.children).length > 0
    },

    notifySelection (item) {
      this.$emit('selection', item)
      this.$refs.treeView.setSelection(item)
    },

    update () {
      this.treeView.updateValues(this.data[0])
    },
    generateID () {
      var ts = (Math.floor(Math.random() * (9999999 - 1000000 + 1)) + 1000000).toString()
      var parts = ts.split('').reverse()
      var id = ''

      for (var i = 0; i < parts.length; ++i) {
        var index = this.getRandomInt(0, parts.length - 1)
        id += parts[index]
      }

      return id
    },
    getRandomInt (min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/TreeView.vue